import AuthService from "./authentication.service";
import { LocalStorageService } from "./local-storage.service";
const {
    REACT_APP_API_PUBLIC_TOKEN,
    REACT_APP_API_CONTRACT_ID,
    REACT_APP_API_CONTRACT_NAME,
} = process.env

function setGuestShareDetails () {
    AuthService.setAccessToken(REACT_APP_API_PUBLIC_TOKEN);
    LocalStorageService.setItem('currentContractId', REACT_APP_API_CONTRACT_ID)
    LocalStorageService.setItem('currentContractName', REACT_APP_API_CONTRACT_NAME)
}

export {setGuestShareDetails}